import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-down-2-icon',
  templateUrl: './navigation-down-2.component.html'
})
export class NavigationDown2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
